<template>
  <div class="safe-details">
    <div class="safe-bg">
      <div class="safe-title">投保人</div>
      <div class="safe-clo">
        <div>姓名：</div>
        <div>{{formData.name}}</div>
      </div>
      <div class="safe-clo">
        <div>订单号：</div>
        <div>{{formData.orderId}}</div>
      </div>
      <div class="safe-clo">
        <div>证件类型：</div>
        <div>{{formData.idType}}</div>
      </div>
      <div class="safe-clo">
        <div>证件号码：</div>
        <div>{{formData.idNo}}</div>
      </div>
      <div class="safe-clo">
        <div>手机号：</div>
        <div>{{formData.phone}}</div>
      </div>
      <div class="safe-clo">
        <div>国家：</div>
        <div>{{formData.national}}</div>
      </div>
      <div class="safe-clo">
        <div>省/县：</div>
        <div>{{formData.province}}/{{formData.district}}</div>
      </div>
      <div class="safe-clo">
        <div>城市名称：</div>
        <div>{{formData.cityName}}</div>
      </div>
      <div class="safe-clo">
        <div>地址：</div>
        <div>{{formData.address}}</div>
      </div>
      <div class="safe-clo">
        <div>公司地址：</div>
        <div>{{formData.companyAddress}}</div>
      </div>
      <div class="safe-clo">
        <div>公司名称：</div>
        <div>{{formData.companyName}}</div>
      </div>
      <div class="safe-clo">
        <div>收入类型：</div>
        <div>{{formData.incomeType}}</div>
      </div>
      <div class="safe-clo">
        <div>职位名称：</div>
        <div>{{formData.profession}}</div>
      </div>
      <div class="safe-clo">
        <div>有无社保：</div>
        <div>{{formData.socialFlag}}</div>
      </div>
      <div class="safe-clo">
        <div>邮编：</div>
        <div>{{formData.postCode}}</div>
      </div>
      <div class="safe-clo">
        <div>邮箱：</div>
        <div>{{formData.email}}</div>
      </div>
      <div class="safe-clo">
        <div>性别：</div>
        <div>{{formData.gender}}</div>
      </div>
      <div class="safe-clo">
        <div>身高：</div>
        <div>{{formData.height}}</div>
      </div>
       <div class="safe-clo">
        <div>生日：</div>
        <div>{{formData.birth}}</div>
      </div>
      <div class="safe-clo">
        <div>婚姻状况：</div>
        <div>{{formData.maritalStatus}}</div>
      </div>
      <div class="safe-clo">
        <div>体重：</div>
        <div>{{formData.weight}}</div>
      </div>
      <div class="safe-line"></div>
      <div class="safe-title">被保人</div>
      <div v-for="(item,index) in insures" :key="index" class="clo-list">
        <div class="safe-clo">
        <div>姓名：</div>
        <div>{{item.name}}</div>
      </div>
      <div class="safe-clo">
        <div>订单号：</div>
        <div>{{item.orderId}}</div>
      </div>
      <div class="safe-clo">
        <div>证件类型：</div>
        <div>{{item.idType}}</div>
      </div>
      <div class="safe-clo">
        <div>证件号码：</div>
        <div>{{item.idNo}}</div>
      </div>
      <div class="safe-clo">
        <div>手机号：</div>
        <div>{{item.phone}}</div>
      </div>
      <div class="safe-clo">
        <div>国家：</div>
        <div>{{item.national}}</div>
      </div>
      <div class="safe-clo">
        <div>省/县：</div>
        <div>{{item.province}}/{{item.district}}</div>
      </div>
      <div class="safe-clo">
        <div>城市名称：</div>
        <div>{{item.cityName}}</div>
      </div>
      <div class="safe-clo">
        <div>地址：</div>
        <div>{{item.address}}</div>
      </div>
      <div class="safe-clo">
        <div>公司地址：</div>
        <div>{{item.companyAddress}}</div>
      </div>
      <div class="safe-clo">
        <div>公司名称：</div>
        <div>{{item.companyName}}</div>
      </div>
      <div class="safe-clo">
        <div>收入类型：</div>
        <div>{{item.incomeType}}</div>
      </div>
      <div class="safe-clo">
        <div>职位名称：</div>
        <div>{{item.profession}}</div>
      </div>
      <div class="safe-clo">
        <div>有无社保：</div>
        <div>{{item.socialFlag}}</div>
      </div>
      <div class="safe-clo">
        <div>邮编：</div>
        <div>{{item.postCode}}</div>
      </div>
      <div class="safe-clo">
        <div>邮箱：</div>
        <div>{{item.email}}</div>
      </div>
      <div class="safe-clo">
        <div>性别：</div>
        <div>{{item.gender}}</div>
      </div>
      <div class="safe-clo">
        <div>身高：</div>
        <div>{{item.height}}</div>
      </div>
       <div class="safe-clo">
        <div>生日：</div>
        <div>{{item.birth}}</div>
      </div>
      <div class="safe-clo">
        <div>婚姻状况：</div>
        <div>{{item.maritalStatus}}</div>
      </div>
      <div class="safe-clo">
        <div>体重：</div>
        <div>{{item.weight}}</div>
      </div>
        <div class="safe-line"></div>
      </div>
    </div>
    <div class="safe-but">
      <van-button round @click="myCreated" color="linear-gradient(to right, #FC6C21, #F85D33)">创建订单</van-button>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
export default {
  data() {
    return {
      formData: {},
      insures: [
        { i: 123, y: 'wee', t: 'uuu', o: 1211 },
        { i: 123, y: 'wee', t: 'uuu', o: 1211 },
        { i: 123, y: 'wee', t: 'uuu', o: 1211 },
      ]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    myCreated() {
      this.$router.push('/createOrder/details')
    },
    getData() {
      this.$fetchGet(URL.safeDetails.url, { id: this.$route.query.id, type: this.$route.query.type }).then(res => {
        this.formData = res.data.data.holder
        this.insures = res.data.data.insures
      })
    }
  }

}
</script>

<style lang="less" scoped>
.safe-details {
  width: 375px;
  height: 100vh;
  overflow: scroll;
  background: #fffbf8;
  font-family: Source Han Sans CN;
  font-weight: Medium;
  .safe-bg {
    width: 355px;
    height: 499px;
    background: #ffffff;
    border-radius: 10px;
    margin: 5px auto auto;
    font-size: 12px;
    color: #333333;
    overflow: scroll;
    .safe-title {
      padding: 21px 0 0 20px;
      font-size: 13px;
      font-weight: 500;
    }
    .safe-clo {
      height: 12px;
      padding: 21px 20px 0 20px;
      display: flex;
      justify-content: space-between;
      div:last-child {
        color: #999999;
      }
    }
    .safe-line {
      width: 334px;
      height: 1px;
      margin: 21px 0 0 6px;
      background: #ededed;
    }
  }
  .clo-list {
    &:last-child > .safe-line {
      display: none;
    }
  }
  .safe-but {
    width: 93px;
    margin: 40px auto auto;
    .van-button {
      width: 93px;
    }
  }
}
</style>